// 表单校验
export default class Validate {


	static validateteleDomain (rule, value, callback) {
		if (value == '') {
			callback()
		}

		const reg = /^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][--a-zA-Z0-9]{0,62})+\.?/
		if (!reg.test(value)) {
			callback(new Error('输入的域名有误，请重新输入！'))
		} else {
			callback()
		}
	}
	static validatemphone (rule, value, callback) {
		if (value == '') {
			callback()
		}
		// 供测试使用
		if (/^(dmr)+\d{8}$/.test(value)) {
			callback()
		}
		if (!/((13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])+\d{8})$/.test(value)) {
			callback(new Error('请输入正确的手机格式'))
		} else {
			callback()
		}
	}

	static enterpriseName (rule, value, callback) {
		if (value == '') {
			callback()
		}
		if (!/^[a-zA-Z0-9\u4e00-\u9fa5\s()（）]+$/i.test(value)) {
			callback(new Error('请输入正确的格式，不支持特殊符号'))
		} else {
			callback()
		}
	}

	static enterpriseMore (rule, value, callback) {
		if (!/^[a-zA-Z0-9\u4e00-\u9fa5\s()（）]+$/i.test(value)) {
			callback(new Error('请输入正确的格式，不支持特殊符号'))
		} else {
			callback()
		}
	}

	static validateImg (rule, value, callback) {
		if (!value) {
			callback(new Error('请上传公司LOGO'))
		} else {
			callback()
		}
	}

	static validatetelephone (rule, value, callback) {
		if (!value) {
			callback()
		} else {
			let len = 0
			for (let i of value) {
				i.charCodeAt(0) > 255 ? len += 2 : len++
			}
			len > 32 ? callback(new Error('最大允许输入32个字符')) : callback()
		}
		// if(value == ''){
		// 	callback()
		// }
		// if (!/^(([0-9]{3,4}-)|([0-9]{3,4})|([0-9]{3,4})\s)?[0-9]{7,8}$/.test(value)) {
		// 	callback(new Error('请输入正确的电话号码格式'))
		// } else {
		// 	callback()
		// }
	}

	static validatemcode (rule, value, callback) {
		if (!/^[0-9]*$/.test(value)) {
			callback(new Error('请输入正确的验证码'))
		} else {
			callback()
		}
	}

	static validatempassword (rule, value, callback) {
		if (!/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z\~\`\!\@\#\$\%\^\&\*\(\)\_\+\=\-\ \,\.\/\;\'\\\[\]\<\>\?\:\"\|\{\}]{6,20}$/.test(value)) {
			callback(new Error('密码长度6-20位，至少包含数字+字母,区分大小写'))
		} else {
			callback()
		}
	}

	static validateemail (rule, value, callback) {
		if (value == '') {
			callback()
		}
		if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)) {
			callback(new Error('请输入正确的邮箱格式'))
		} else {
			callback()
		}
	}

	static unifiedStyle (rule, value, callback) {
		callback()
	}

	static max100 (rule, value, callback) {
		if (value == '') {
			callback()
		}
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 100 ? callback(new Error('最大允许输入100个字符')) : callback()
	}

	static max128 (rule, value, callback) {
		if (value == '') {
			callback()
		}
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 128 ? callback(new Error('最大允许输入128个字符')) : callback()
	}

	static max200 (rule, value, callback) {
		if (value == '') {
			callback()
		}
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		len > 200 ? callback(new Error('最大允许输入200个字符')) : callback()
	}

	static taxNumber (rule, value, callback) {
		let len = 0
		for (let i of value) {
			i.charCodeAt(0) > 255 ? len += 2 : len++
		}
		(len < 6 || len > 20) ? callback(new Error('税号只支持6-20位')) : callback()
	}
}
